<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import SkistarAccommodationFilter from '../../../components/ski/skistar/SkistarAccommodationFilter';
import SkistarAccommodationImages from '../../../components/ski/skistar/SkistarAccommodationImages';
import SkistarAccommodationImportStatus from '../../../components/ski/skistar/SkistarAccommodationImportStatus';
import SkistarAccommodationText from '../../../components/ski/skistar/SkistarAccommodationText';
import TwConfirmDialog from '../../../components/TwConfirmDialog';

export default {
  name: 'SkistarResortAccommodations',
  components: {
    SkistarAccommodationImportStatus,
    SkistarAccommodationImages,
    SkistarAccommodationText,
    SkistarAccommodationFilter,
    TwConfirmDialog,
  },
  data() {
    return {
      headers: [
        { text: this.$t('skistar.accommodations.table.headers.id'), class: 'px-1', value: 'id' },
        { text: this.$t('skistar.accommodations.table.headers.name'), class: 'px-2', value: 'name' },
        { text: this.$t('skistar.accommodations.table.headers.description'), class: 'px-2', value: 'description' },
        { text: this.$t('skistar.accommodations.table.headers.areaName'), class: 'px-2', value: 'areaName' },
        { text: this.$t('skistar.accommodations.table.headers.subareaName'), class: 'px-2', value: 'subareaName' },
        {
          text: this.$t('skistar.accommodations.table.headers.details'),
          class: 'px-2',
          value: '',
          align: 'center',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 20,
      },
      paginationRowsPerPage: [
        20,
        50,
        { text: 'All', value: -1 },
      ],
    };
  },
  methods: {
    ...mapActions({
      showAccommodationTexts: 'skistar/showAccommodationTexts',
      showAccommodationImages: 'skistar/showAccommodationImages',
      showAccommodationImportStatus: 'skistar/showAccommodationImportStatus',
      toggleAccommodationSelection: 'skistar/toggleAccommodationSelection',
      toggleAccommodationSelectionAll: 'skistar/toggleAccommodationSelectionAll',
      unmapAccommodation: 'skistar/unmapAccommodation',
      unmapAccommodationFinalize: 'skistar/unmapAccommodationFinalize',
      unmapAccommodationReset: 'skistar/unmapAccommodationReset',
      loadStockPriceProducts: 'skistar/loadStockPriceProducts',
      loadResortAccommodations: 'skistar/loadResortAccommodations',
    }),
    toggleAll() {
      let selection = [];
      if (!this.selected.length) {
        selection = this.unimportedAccommodations.slice().map(accommodation => accommodation.id);
      }
      this.toggleAccommodationSelectionAll(selection);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    startUnmapping(xmlChannelProductId) {
      this.unmapAccommodation(xmlChannelProductId);
      this.$refs.unmapDialog.open();
    },
    loadAccommodations() {
      this.loadStockPriceProducts();
      this.loadResortAccommodations();
    },
  },
  computed: {
    ...mapState({
      resortId: state => state.skistar.resorts.resort,
      webservice: state => state.skistar.resorts.webservice,
      accommodations: state => state.skistar.accommodations.items,
      selected: state => state.skistar.accommodations.selected,
      itemsLoading: state => state.skistar.accommodations.itemsLoading,
      search: state => state.skistar.accommodations.search,
      subarea: state => state.skistar.accommodations.subarea,
      accommodationSelected: state => state.skistar.accommodation.selected,
      accommodationTexts: state => state.skistar.accommodation.texts.items,
      accommodationTextsLoading: state => state.skistar.accommodation.texts.itemsLoading,
      accommodationTextsShow: state => state.skistar.accommodation.texts.show,
      accommodationImages: state => state.skistar.accommodation.images.items,
      accommodationImagesLoading: state => state.skistar.accommodation.images.itemsLoading,
      accommodationImagesShow: state => state.skistar.accommodation.images.show,
      unmapLoading: state => state.skistar.accommodations.unmapLoading,
      unmap: state => state.skistar.accommodations.unmap,
      statusLoading: state => state.skistar.import.status.itemsLoading,
      accommodationImportStatusShow: state => state.skistar.accommodation.importStatus.show,
    }),
    ...mapGetters({
      filteredAccommodations: 'skistar/getAccommodations',
      selectedAccommodations: 'skistar/getSelectedAccommodations',
      unimportedAccommodations: 'skistar/getUnimportedAccommodations',
    }),
    checkboxIndeterminate() {
      return this.selected.length > 0 && this.selected.length
        !== this.unimportedAccommodations.length;
    },
    checkboxStatus() {
      return this.selected.length > 0 && this.selected.length
        === this.unimportedAccommodations.length;
    },
  },
  mounted() {
    if (this.resortId) {
      this.loadAccommodations();
    }
  },
  watch: {
    resortId() {
      this.loadAccommodations();
    },
  },
};
</script>

<template>
  <v-card>
    <tw-confirm-dialog
      @confirm="unmapAccommodationFinalize"
      @cancel="unmapAccommodationReset"
      :title="this.$t('skistar.accommodations.unmap.title')"
      :description="this.$t('skistar.accommodations.unmap.description')"
      ref="unmapDialog"
    />
    <v-container fluid>
      <v-layout row>
        <v-flex xs12>
            <skistar-accommodation-filter
              :disabled="itemsLoading || statusLoading || unmapLoading"
              :selected-accommodations="selectedAccommodations"
            >
            </skistar-accommodation-filter>
            <skistar-accommodation-import-status
              v-if="accommodationImportStatusShow"
            />
            <skistar-accommodation-text
              v-if="accommodationSelected && accommodationTextsShow"
              :id="accommodationSelected.id"
              :name="accommodationSelected.name"
              :texts="accommodationTexts"
              :show="accommodationTextsShow"
              :loading="accommodationTextsLoading"
            >
            </skistar-accommodation-text>
            <skistar-accommodation-images
              v-if="accommodationSelected && accommodationImagesShow"
              :id="accommodationSelected.id"
              :name="accommodationSelected.name"
              :images="accommodationImages"
              :show="accommodationImagesShow"
              :loading="accommodationImagesLoading"
            >
            </skistar-accommodation-images>
            <v-data-table
              :items="filteredAccommodations"
              :headers="headers"
              :loading="itemsLoading || statusLoading || unmapLoading"
              :no-results-text="$t('skistar.accommodations.table.noResults')"
              :pagination.sync="pagination"
              :rows-per-page-items="paginationRowsPerPage"
              class="print"
              item-key="id"
              must-sort
            >
              <template v-slot:headers="props">
                <tr>
                  <th class="px-1">
                    <v-checkbox
                      @click.stop="toggleAll"
                      :input-value="checkboxStatus"
                      :indeterminate="checkboxIndeterminate"
                      primary
                      hide-details
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    @click="changeSort(header.value)"
                    :key="header.text"
                    :class="['column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.class ? header.class : '',
                      header.align ? 'text-xs-' + header.align : 'text-xs-left'
                    ]"
                  >
                    {{ header.text }}
                    <v-icon small>arrow_upward</v-icon>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr :class="{'red lighten-2': !props.item.partOfLatestImport}">
                  <td class="px-1">
                    <v-icon
                      v-if="props.item.imported"
                      color="success"
                      flat
                    >
                      check_circle
                    </v-icon>
                    <v-checkbox
                      v-else
                      @click.stop="toggleAccommodationSelection(props.item.id)"
                      :input-value="props.item.selected"
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="px-1">{{ props.item.id }}</td>
                  <td class="px-2">{{ props.item.name }}</td>
                  <td class="px-2">{{ props.item.description }}</td>
                  <td class="px-2">{{ props.item.subarea.area.name }}</td>
                  <td class="px-2">{{ props.item.subarea.name }}</td>
                  <td class="px-2 text-xs-center">
                    <v-btn
                      @click="showAccommodationImportStatus(props.item)"
                      :disabled="!props.item.imported"
                      color="success"
                      class="ma-0"
                      flat
                      icon
                      small
                    >
                      <v-icon>info</v-icon>
                    </v-btn>
                    <v-btn
                      @click="showAccommodationImages(props.item)"
                      :color="props.item.hasOldImagesImported ? 'red' : 'primary'"
                      class="ma-0"
                      flat
                      icon
                      small
                    >
                      <v-icon>camera_alt</v-icon>
                    </v-btn>
                    <v-btn
                      @click="showAccommodationTexts(props.item)"
                      color="primary"
                      class="ma-0"
                      flat
                      icon
                      small
                    >
                      <v-icon>text_fields</v-icon>
                    </v-btn>
                    <v-btn
                      @click="startUnmapping(props.item.xmlChannelProductId)"
                      :loading="unmapLoading && unmap === props.item.xmlChannelProductId"
                      :disabled="!props.item.imported"
                      color="red"
                      class="ma-0"
                      flat
                      icon
                      small
                    >
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skistar/SkistarResortAccommodations.vue